import { Component } from '@angular/core';

@Component({
  selector: 'app-politique-confidentialite',
  imports: [],
  templateUrl: './politique-confidentialite.component.html',
  styleUrls: ['../../../assets/styles/pages-legales.css'],
})
export class PolitiqueConfidentialiteComponent {}
